<a class="logo-container" routerLink="/sessions" aria-label="Go to start page">
  <img class="logo-image" src="assets/spectrace_logo_single.png" alt="SpecTrace logo" />

  <!-- Text Logo -->
  <div class="logo-text">
    <h1 class="brand-name">
      <span class="brand-primary">SPEC</span>
      <span class="brand-secondary">TRACE</span>
    </h1>
  </div>
</a>
